import header from './header';

window.addEventListener( 'load', () => {
	header.init();
} );
